<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-success opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-right mt-0 mt-md-4 mt-lg-0">
            <router-link
              :to="`/admin/batches/${$route.params.idBatch}/acompanhamento/startups/${$route.params.idStartup}/cards`"
              class="btn-link font-weight-normal text-white"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar para a lista de
              cards da startup</router-link
            >
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-12">
          <card shadow>
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">
                    Novo card
                    <span v-if="startup" class="text-orange">{{
                      startup.name
                    }}</span>
                  </h3>
                </div>
              </div>
            </div>
            <div class="vld-parent" ref="form_container">
              <h6 class="heading-small text-muted mb-4">Informações básicas</h6>
              <div class="pl-lg-4">
                <div class="row">
                  <div class="col-lg-6">
                    <base-input label="Visível no painel da startup?">
                      <br />
                      <base-switch
                        v-bind:value="model.show_startup"
                        @input="showStartupChangedHandler($event)"
                      />
                    </base-input>
                  </div>
                  <div class="col-lg-6">
                    <base-input label="Visível no painel dos investidores?">
                      <br />
                      <base-switch
                        v-bind:value="model.show_investors"
                        @input="showInvestorsChangedHandler($event)"
                      />
                    </base-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <base-input
                      label="Título do card"
                      v-model="model.title"
                      placeholder="Digite o título"
                    />
                  </div>
                  <div class="col-lg-6">
                    <base-input label="Captable ou investimento?">
                      <br />
                      <base-switch
                        v-bind:value="model.captable_related"
                        @input="captableRelatedChangedHandler($event)"
                      />
                    </base-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <base-input
                      label="Subtítulo do card (opcional)"
                      v-model="model.subtitle"
                      placeholder="Digite o subtítulo"
                    />
                  </div>
                  <div class="col-lg-6">
                    <label class="form-control-label"> Tipo do card </label>
                    <div>
                      <base-input>
                        <select class="form-control" v-model="model.type">
                          <option selected disabled value="">
                            Selecione o tipo do card
                          </option>
                          <option
                            v-for="type in cardTypes"
                            :key="type.key"
                            :value="type.key"
                          >
                            {{ type.value }}
                          </option>
                        </select>
                      </base-input>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="my-4" />
              <div v-if="model.type">
                <div v-if="model.type === 'text'">
                  <h6 class="heading-small text-muted mb-4">
                    Texto/valor a ser exibido
                  </h6>
                  <div class="pl-lg-4">
                    <div class="row">
                      <div
                        class="col-lg-12 sc-container-edditable"
                        v-if="model.type === 'text'"
                      >
                        <quill-editor
                          v-model="model.text_data"
                          :options="editorEdittable"
                        >
                        </quill-editor>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <h6 class="heading-small text-muted mb-4">
                    Dados do gráfico
                  </h6>
                  <div class="pl-lg-4 pl-md-0">
                    <div
                      v-for="(point, index) in model.chart_data"
                      :key="'point_' + index"
                      class="row mb-1"
                    >
                      <div class="col-12">
                        <div
                          class="mb-1 d-flex align-items-center justify-content-between"
                        >
                          <span class="form-control-label"
                            >Ponto/Setor {{ index + 1 }}</span
                          >
                          <base-button
                            type="link"
                            class="text-danger"
                            :iconOnly="true"
                            icon="fas fa-times"
                            @click="handleRemovePoint(index)"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <base-input placeholder="Label" v-model="point.label" />
                      </div>
                      <div class="col-lg-6 mt-2 mt-lg-0">
                        <base-input
                          placeholder="Valor"
                          type="number"
                          v-model="point.data"
                        />
                      </div>
                    </div>
                    <div class="mt-3 text-right">
                      <base-button
                        @click="handleAddNewPoint"
                        size="sm"
                        :custom="true"
                        >Adicionar novo</base-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-center mt-4">
                  <base-alert type="danger" v-if="error" class="mb-4">{{
                    error
                  }}</base-alert>
                  <base-button
                    type="primary"
                    :custom="true"
                    @click="handleCreateCard"
                    :disabled="!isValidModel"
                  >
                    Adicionar card
                  </base-button>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import api from "@/services/api.js";

export default {
  name: "admin-startup-card",
  components: {
    quillEditor,
  },
  data() {
    return {
      startup: "",
      model: {
        title: "",
        subtitle: "",
        type: "",
        show_startup: false,
        show_investors: false,
        captable_related: false,
        text_data: "",
        chart_data: [{ label: "", data: "" }],
      },
      cardTypes: [
        { key: "text", value: "Textual" },
        { key: "pie_chart", value: "Gráfico de setores (pizza)" },
        { key: "line_chart", value: "Gráfico de linha" },
      ],
      error: "",
      editorEdittable: {
        placeholder: "Escreva aqui...",
      },
    };
  },
  async mounted() {
    try {
      const { data: startup } = await api.get(
        `/adm/startups/${this.$route.params.idStartup}`
      );
      if (!startup) throw new Error("Startup not found");
      this.startup = startup;
    } catch (e) {
      this.$toasted.error("Error ao carregar as informações da startup");
      this.$router.push(
        `/admin/batches/${this.$route.params.idBatch}/acompanhamento`
      );
    }
  },
  methods: {
    async handleCreateCard() {
      let loader = this.$loading.show({
        container: this.$refs.form_container,
        width: 140,
        height: 140,
      });
      try {
        const idBatch = this.$route.params.idBatch;
        const idStartup = this.$route.params.idStartup;
        await api.post(
          `/startup-cards/batches/${idBatch}/startups/${idStartup}`,
          this.model
        );
        this.$toasted.show("Novo card criado com sucesso");
        this.$router.push(
          `/admin/batches/${idBatch}/acompanhamento/startups/${idStartup}/cards`
        );
      } catch (e) {
        this.error =
          "Ocorreu um erro ao criar o card. Verifique as informações e tente novamente.";
        this.$toasted.error("Ocorreu um erro ao salvar as informações");
      }
      loader.hide();
    },
    showStartupChangedHandler(event) {
      if (typeof event === "boolean") this.model.show_startup = event;
    },
    showInvestorsChangedHandler(event) {
      if (typeof event === "boolean") this.model.show_investors = event;
    },
    captableRelatedChangedHandler(event) {
      if (typeof event === "boolean") this.model.captable_related = event;
    },
    handleAddNewPoint() {
      this.model.chart_data.push({ label: "", data: "" });
    },
    handleRemovePoint(index) {
      this.model.chart_data.splice(index, 1);
    },
  },
  computed: {
    isValidModel() {
      const model = this.model;
      if (!model.title || !model.type) return false;
      if (model.type === "text" && model.text_data) return true;
      return model.type !== "text" && model.chart_data.length;
    },
  },
};
</script>
<style>
.sc-container-edditable .quill-editor .ql-container,
.sc-container-edditable .quill-editor .ql-container .ql-editor {
  min-height: 11rem;
  width: 100%;
}

p > strong {
  font-weight: bold !important;
}
</style>
